import dayjs from 'core/utils/dayjs';

export const defineRequestStartDate = (dayInPast = 90) => dayjs().subtract(dayInPast, 'days').format('YYYY-MM-DD');
export const defineRequestEndDate = () => dayjs().add(1, 'days').format('YYYY-MM-DD');
